import React from 'react';
import ChatUI from './ChatUI';
import "./index.less";

export default function index(props) {
  const {
    mode
  } = props
  return (
    (window.ifBanner && mode === "single") ?
      <div className={`${mode === "single" && "newBanner"} `}>
        <div className='newBannerHeader' style={{
          height: window.bannerHeight,
          background: window.background
        }}>
          <div style={{
            height: "100%",
            padding: "10px"
          }} >

            <img style={{
              height: "40px"
            }} src={window.bannnerImg} />
          </div>
        </div>
        <div style={{
          height: `calc(100% - ${window.bannerHeight})`
        }}>
          <ChatUI {...props} />
        </div>

      </div> : <ChatUI {...props} />

  )
}
